var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoveCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 84,
  height: 84,
  stroke: "#1274C4"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  r: 40
}), /*#__PURE__*/React.createElement("path", {
  d: "m24 56 32-32m0 32L24 24"
}))));
export { SvgRemoveCircle as ReactComponent };
export default __webpack_public_path__ + "assets/media/remove-circle.7759a3a407c2bb9ed79ecc9c905fdeb6.svg";